/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        // this identifies your website in the createToken call below

        Stripe.setPublishableKey('pk_live_3tKCsRuCoBT1y36RPvUNT5Wk');
        
        function stripeResponseHandler(status, response) {
          
            if (response.error) {
                // re-enable the submit button
                jQuery('.submit-button').removeAttr("disabled");
                // show the errors on the form
                jQuery(".payment-errors").html(response.error.message).addClass("alert alert-danger");
            } else {
                var form$ = jQuery("#payment-form");
                // token contains id, last4, and card type
                var token = response['id'];
                // insert the token into the form so it gets submitted to the server
                form$.append("<input type='hidden' name='stripeToken' value='" + token + "' />");
                // and submit
                form$.get(0).submit();
            }
          
        }

        $('#payment-form input').change(function(){ // run anytime the value changes
          
          var o1= Number($('#option_input_1').val()) || 0;
          var o2= Number($('#option_input_2').val()) || 0;
          var o3= Number($('#option_input_3').val())|| 0;
          var o4= Number($('#option_input_4').val())|| 0;
          var o5= Number($('#option_input_5').val())|| 0;
          var o6= Number($('#option_input_6').val())|| 0;

          var m1= Number($('#montant_input_1').val())|| 0;
          var m2= Number($('#montant_input_2').val())|| 0;
          var m3= Number($('#montant_input_3').val())|| 0;
          var m4= Number($('#montant_input_4').val())|| 0;
          var m5= Number($('#montant_input_5').val())|| 0;
          var m6= Number($('#montant_input_6').val())|| 0;

          var d1= Number($('#dispo_input_1').val())|| 0;
          var d2= Number($('#dispo_input_2').val())|| 0;
          var d3= Number($('#dispo_input_3').val())|| 0;
          var d4= Number($('#dispo_input_4').val())|| 0;
          var d5= Number($('#dispo_input_5').val())|| 0;
          var d6= Number($('#dispo_input_6').val())|| 0;

          if (o1===d1){
             
            $('.liste-attente_1').show();
          }
          else{
            $('#waiting_input_1').val('0');  
            $('.liste-attente_1').hide();
          }

          if (o2===d2){
            $('.liste-attente_2').show();
          }
          else{
            $('.liste-attente2').hide();
            $('.liste-attente_2').hide();
          }

          if (o3===d3){
            $('.liste-attente_3').show();
          }
          else{
            $('.liste-attente_3').hide();
            $('.liste-attente_3').hide();
          }

          if (o4===d4){
            $('.liste-attente_4').show();
          }
          else{
            $('.liste-attente_4').hide();
            $('.liste-attente_4').hide();
          }

          if (o5===d5){
            $('.liste-attente_5').show();
          }
          else{
            $('.liste-attente_5').hide();
            $('.liste-attente_5').hide();
          }

          if (o6===d6){
            $('.liste-attente_6').show();
          }
          else{
            $('.liste-attente_6').hide();
            $('.liste-attente_6').hide();
          }
            

          
          var mt = o1*m1 + o2*m2 + o3*m3 + o4*m4 + o5*m5 + o6*m6;
          document.getElementById('montant_total').value = mt;

          if (mt==0){
            $('.box_moyen_paiement').css("display","none");
          }
          else {
            $('.box_moyen_paiement').css("display","block");
          }

          if (( mt>0) && $('input[name=moyen_paiement]:checked', '#payment-form').val()==='carte_de_credit') {
            $('#payment-form .boxpayform').css("display","block");
          }
          else {
            $('#payment-form .boxpayform').css("display","none");
          }
          
          jQuery("#payment-form").submit(function(event) {
            // disable the submit button to prevent repeated clicks
            jQuery('.submit-button').attr("disabled", "disabled");
            // createToken returns immediately - the supplied callback submits the form if there are no errors
            var o1= Number($('#option_input_1').val()) || 0;
            var o2= Number($('#option_input_2').val()) || 0;
            var o3= Number($('#option_input_3').val())|| 0;
            var o4= Number($('#option_input_4').val())|| 0;
            var o5= Number($('#option_input_5').val())|| 0;
            var o6= Number($('#option_input_6').val())|| 0;

            var m1= Number($('#montant_input_1').val())|| 0;
            var m2= Number($('#montant_input_2').val())|| 0;
            var m3= Number($('#montant_input_3').val())|| 0;
            var m4= Number($('#montant_input_4').val())|| 0;
            var m5= Number($('#montant_input_5').val())|| 0;
            var m6= Number($('#montant_input_6').val())|| 0;
            mt = o1*m1 + o2*m2 + o3*m3 + o4*m4 + o5*m5 + o6*m6;
            
            if ((mt>0) && $('input[name=moyen_paiement]:checked', '#payment-form').val()==='carte_de_credit'){  
                         
              Stripe.createToken({
                  number: jQuery('.card-number').val(),
                  cvc: jQuery('.card-cvc').val(),
                  exp_month: jQuery('.card-expiry-month').val(),
                  exp_year: jQuery('.card-expiry-year').val()
              }, stripeResponseHandler);
              
              return false; // submit from callback
            }
        });

        // add them and output it
        });

        jQuery(document).ready(function() {
          var o1= Number($('#option_input_1').val()) || 0;
          var o2= Number($('#option_input_2').val()) || 0;
          var o3= Number($('#option_input_3').val()) || 0;
          var o4= Number($('#option_input_4').val()) || 0;
          var o5= Number($('#option_input_5').val()) || 0;
          var o6= Number($('#option_input_6').val()) || 0;

          var m1= Number($('#montant_input_1').val()) || 0;
          var m2= Number($('#montant_input_2').val()) || 0;
          var m3= Number($('#montant_input_3').val()) || 0;
          var m4= Number($('#montant_input_4').val()) || 0;
          var m5= Number($('#montant_input_5').val()) || 0;
          var m6= Number($('#montant_input_6').val()) || 0;

          var d1= Number($('#dispo_input_1').val())|| 0;
          var d2= Number($('#dispo_input_2').val())|| 0;
          var d3= Number($('#dispo_input_3').val())|| 0;
          var d4= Number($('#dispo_input_4').val())|| 0;
          var d5= Number($('#dispo_input_5').val())|| 0;
          var d6= Number($('#dispo_input_6').val())|| 0;

          var mt= o1*m1 + o2*m2 + o3*m3 + o4*m4 + o5*m5 + o6*m6;
          document.getElementById('montant_total').value = mt;

          console.log(d1);
          console.log(o1);

          if (o1===d1){   
            $('.liste-attente_1').show();
          }
          else{
            $('#waiting_input_1').val('0');
            $('.liste-attente_1').hide();
            
          }

          if (o2===d2){
            $('.liste-attente_2').show();
          }
          else{
            $('.liste-attente_2').hide();
            $('.liste-attente_2').hide();
          }

          if (o3===d3){
            $('.liste-attente_3').show();
          }
          else{
            $('.liste-attente_3').hide();
            $('.liste-attente_3').hide();
          }

          if (o4===d4){
            $('.liste-attente_4').show();
          }
          else{
            $('.liste-attente_4').hide();
            $('.liste-attente_4').hide();
          }

          if (o5===d5){
            $('.liste-attente_5').show();
          }
          else{
            $('.liste-attente_5').hide();
            $('.liste-attente_5').hide();
          }

          if (o6===d6){
            $('.liste-attente_6').show();
          }
          else{
            $('.liste-attente_6').hide();
            $('.liste-attente_6').hide();
          }
            
          
          if (mt==0){
            $('.box_moyen_paiement').css("display","none");
          }
          else {
            $('.box_moyen_paiement').css("display","block");
          }
          
          if (( mt>0) && $('input[name=moyen_paiement]:checked', '#payment-form').val()==='carte_de_credit'){
            $('#payment-form .boxpayform').css("display","block");
          }
          else {
            $('#payment-form .boxpayform').css("display","none");
          }
          
          jQuery("#payment-form").submit(function(event) {
              // disable the submit button to prevent repeated clicks
              jQuery('.submit-button').attr("disabled", "disabled");
              // createToken returns immediately - the supplied callback submits the form if there are no errors
              if ((mt>0) && $('input[name=moyen_paiement]:checked', '#payment-form').val()==='carte_de_credit'){
                
              Stripe.createToken({
                  number: jQuery('.card-number').val(),
                  cvc: jQuery('.card-cvc').val(),
                  exp_month: jQuery('.card-expiry-month').val(),
                  exp_year: jQuery('.card-expiry-year').val()
              }, stripeResponseHandler);
              
              return false; // submit from callback
              }
          });
          

        });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
